import React from "react";
import PreviewImage from "./PreviewImage";
import { PieChart } from "react-minimal-pie-chart";
import Rating from "./Rating";
import Progress from "./Progress";
import { CourseResource } from "../../../../../stores/CoursesStore/Types";
import CourseBadge from "../CourseBadge";

interface Props {
  courseResource: CourseResource;
  userIsInUk: boolean;
}

const CourseBody: React.FC<Props> = ({ courseResource, userIsInUk }) => {
  const brandLogo = (courseResource, userIsInUk) => {
    if (userIsInUk && courseResource.brand_alt_logo_url) {
      return (
        <div className="course-logo">
          <img src={courseResource.brand_alt_logo_url} alt="brand" />
        </div>
      );
    }

    if (courseResource.brand_logo_url) {
      return (
        <div className="course-logo">
          <img src={courseResource.brand_logo_url} alt="brand" />
        </div>
      );
    }

    return null;
  };

  return (
    <div className="copyWrap">
      <div className="bg">
        {courseResource.subscription_only &&
          !courseResource.has_subscription && (
            <div id="overlay">
              <div id="text">
                <i className="lock icon"></i>

                <span>Subscriber Only</span>
              </div>
            </div>
          )}
        <div className="course-status">
          <CourseBadge courseResource={courseResource} />
        </div>
        <div className="course-headshot">
          <PreviewImage
            courseResource={courseResource}
            userIsInUk={userIsInUk}
          />
          {brandLogo(courseResource, userIsInUk)}
        </div>
      </div>
      <div className="main">
        <div className="title">{courseResource.name}</div>
        <p className="teaser">{courseResource.preview_mini_description}</p>
      </div>
      {courseResource.enrolled_student_present ? (
        <div className="course_footer ongoing">
          <div className="progress">
            <PieChart
              data={[
                {
                  value: courseResource.enrolment_percent_completion,
                  color: "#0D99FF",
                },
                {
                  label: "",
                  value: 100 - courseResource.enrolment_percent_completion,
                  isEmpty: true,
                  color: "#dbdee4",
                },
              ]}
              totalValue={100}
              lineWidth={20}
              label={() => `${courseResource.enrolment_percent_completion}%`}
              labelStyle={{
                fontSize: "30px",
                fill: "392D40",
              }}
              labelPosition={0}
              startAngle={270}
            />
            <div className="fl-button highlight" style={{ cursor: "pointer" }}>
              {courseResource.enrolment_percent_completion === 100
                ? "View Again"
                : "Continue"}
            </div>
          </div>
        </div>
      ) : (
        <div className="course_footer">
          <div className="course-rating">
            <Rating courseResource={courseResource} />
          </div>
          <Progress courseResource={courseResource} />{" "}
        </div>
      )}
    </div>
  );
};

export default CourseBody;
